import { DistributionService } from "@/types/episode";

// ============================================
// Podcast Distribution Services
// Synced with Podlink platform list
// ============================================

export const DISTRIBUTION_SERVICES: DistributionService[] = [
  { id: 'spotify', name: 'Spotify', isPremium: false },
  { id: 'apple-podcasts', name: 'Apple Podcasts', isPremium: false },
  { id: 'youtube-music', name: 'YouTube Music', isPremium: false },
  { id: 'iheartradio', name: 'iHeartRadio', isPremium: false },
  { id: 'deezer', name: 'Deezer', isPremium: false },
  { id: 'pandora', name: 'Pandora', isPremium: false },
  { id: 'podcast-addict', name: 'Podcast Addict', isPremium: false },
  { id: 'castbox', name: 'Castbox', isPremium: false },
  { id: 'podbean', name: 'Podbean', isPremium: false },
  { id: 'player-fm', name: 'Player FM', isPremium: false },
  { id: 'goodpods', name: 'Goodpods', isPremium: false },
  { id: 'tunein', name: 'TuneIn', isPremium: false },
  { id: 'overcast', name: 'Overcast', isPremium: false },
  { id: 'castro', name: 'Castro', isPremium: false },
  { id: 'castamatic', name: 'Castamatic', isPremium: false },
  { id: 'fountain', name: 'Fountain', isPremium: false },
  { id: 'ivoox', name: 'iVoox', isPremium: false },
  { id: 'gpodder', name: 'gPodder', isPremium: false },
  { id: 'curiocaster', name: 'CurioCaster', isPremium: false },
  { id: 'ln-beats', name: 'LN Beats', isPremium: false },
  { id: 'truefans', name: 'TrueFans', isPremium: false },
  { id: 'rssradio', name: 'RSS Radio', isPremium: false },
  { id: 'podverse', name: 'Podverse', isPremium: false },
  { id: 'podurama', name: 'Podurama', isPremium: false },
  { id: 'podstation', name: 'Podstation', isPremium: false },
  { id: 'podcast-republic', name: 'Podcast Republic', isPremium: false },
  { id: 'podcast-guru', name: 'Podcast Guru', isPremium: false },
  { id: 'podcast-app', name: 'Podcast App', isPremium: false },
  { id: 'pocketcasts', name: 'Pocket Casts', isPremium: false },
  { id: 'moon-fm', name: 'Moon FM', isPremium: false },
  { id: 'global-player', name: 'Global Player', isPremium: false },
  { id: 'downcast', name: 'Downcast', isPremium: false },
  { id: 'breez', name: 'Breez', isPremium: false },
  { id: 'audible', name: 'Audible', isPremium: false },
  { id: 'anytime-podcast-player', name: 'Anytime Podcast Player', isPremium: false },
  { id: 'antennapod', name: 'AntennaPod', isPremium: false },
];

// ============================================
// Languages (ISO 639-1)
// ============================================

export interface Language {
  code: string;
  name: string;
}

export const LANGUAGES: Language[] = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Spanish' },
  { code: 'fr', name: 'French' },
  { code: 'de', name: 'German' },
  { code: 'pt', name: 'Portuguese' },
  { code: 'it', name: 'Italian' },
  { code: 'ja', name: 'Japanese' },
  { code: 'ko', name: 'Korean' },
  { code: 'zh', name: 'Chinese (Mandarin)' },
  { code: 'ar', name: 'Arabic' },
  { code: 'hi', name: 'Hindi' },
  { code: 'ru', name: 'Russian' },
  { code: 'nl', name: 'Dutch' },
  { code: 'pl', name: 'Polish' },
  { code: 'tr', name: 'Turkish' },
  { code: 'sv', name: 'Swedish' },
  { code: 'da', name: 'Danish' },
  { code: 'no', name: 'Norwegian' },
  { code: 'fi', name: 'Finnish' },
  { code: 'th', name: 'Thai' },
  { code: 'vi', name: 'Vietnamese' },
  { code: 'id', name: 'Indonesian' },
  { code: 'ms', name: 'Malay' },
  { code: 'tl', name: 'Tagalog' },
  { code: 'uk', name: 'Ukrainian' },
  { code: 'cs', name: 'Czech' },
  { code: 'el', name: 'Greek' },
  { code: 'he', name: 'Hebrew' },
  { code: 'hu', name: 'Hungarian' },
  { code: 'ro', name: 'Romanian' },
];
